import { SessionConfig } from "@/utils/types"

import { dexie } from "../../db"
import { logDexieError } from "../../utils/logDexieError"

// ─── Types ─────────────────────────────────────────────────────────────────────

export type ConfigLocal = Omit<SessionConfig, "orderedSteps"> & { dexieId: number; sessionId: string }

// ─── Methods ───────────────────────────────────────────────────────────────────

export async function upsertConfig(data: Omit<ConfigLocal, "dexieId">): Promise<void> {
  try {
    await dexie.transaction("rw", dexie.config, async () => {
      const existing = await dexie.config.where("sessionId").equals(data.sessionId).first()
      if (existing) {
        await dexie.config.update(existing.dexieId, data)
      } else {
        await dexie.config.add(data as ConfigLocal)
      }
    })
  } catch (error) {
    logDexieError(error)
  }
}

export async function getConfig(sessionId: string): Promise<ConfigLocal | undefined> {
  try {
    return await dexie.config.where("sessionId").equals(sessionId).first()
  } catch (error) {
    logDexieError(error)
  }
}
